import {HotelInfo, hotelList} from "../types/Hotel";

export const defaultHotelDetail:hotelList = {
  address: "",
  hotel_code: "",
  hotel_detail_url: "",
  hotel_name: "",
  hotel_type_list: [{hotel_type_code: ""}],
  hotel_facility_list: [],
  image_l_url: "",
  image_m_url: "",
  lang_support_staff: "",
  map_latitude: "",
  map_longitude: "",
  min_price: 0,
  postal_code: "",
  pr_main_description: "",
  review_rating: "",
  hotelData: {
    hotel_info: {
      hotel_code: "",
      hotel_name: "",
      tel: "",
      fax: "",
      parking: "",
      pickup_bus: "",
      total_room_num: "",
      check_in_start: "",
      check_in_end: "",
      check_in_other: "",
      check_out: "",
      other_notes: "",
      map_latitude: "",
      map_longitude: "",
      address: "",
      distance: "",
      access: "",
      map_code: "",
      pr_main_image_l_url: "",
      pr_main_image_m_url: "",
      pr_main_title: "",
      pr_main_description: "",
      pr_list: [{
        pr_image_url: "",
        pr_title: "",
        pr_description: ""
      }],
      room_equipment_list: [{
        name: ""
      }],
      room_amenity_list: [{
        name: ""
      }],
      credit_list: [{
        name: ""
      }],
      hotel_facility_list: [{
        name: ""
      }],
      barrierfree_list: [{
        name: ""
      }],
      barrierfree_remarks: ""
    },
    room_list:[{
      min_price: 0,
      plan_list: [],
      room_code: "",
      room_name: "",
      room_type_code: "",
    }],
  },
  roomData: [],
  room_url: "",
  sold_out_flg: 0,
  sub_area_code: undefined,
  sub_area_name: undefined,
}